import { Point } from '@root/app.interfaces';

export class FitModelError extends Error {
	constructor(
		message: string,
		public coords: Point[],
	) {
		super(message);
		this.name = 'FitModelError';
	}
}
